import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyABUeoGyyjCaDJmDpZvhsPwANtnRqhhBQQ',
  authDomain: 'mredonda.firebaseapp.com',
  databaseURL: 'https://mredonda.firebaseio.com',
  projectId: 'mredonda',
  storageBucket: 'mredonda.appspot.com',
  messagingSenderId: '522703120127',
  appId: '1:522703120127:web:74da5833e68dffd1214eca',
  measurementId: 'G-4ZHM0J3EY5',
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();
const db = firebase.firestore();
export { storage, db, firebase as default };
